module.exports = "/assets/data/feff40a1b50d35e47a4da7687256c595-CW6.data.json";